export default __webpack_public_path__ + "static/media/nl-design.68789d9e.webp";